export default {
    ProductCard: {
        card: 'product-card text-center flex flex-col justify-around h-full w-4/12',
        mediaWrapper: '',
        cardMedia: 'w-full',
        contentWrapper: 'flex flex-col justify-end h-full',
        cardContent: 'px-2 py-1',
        cardActions: 'px-6 py-1',
        header: 'font-sans-bold block text-center text-black text-15 leading-normal pt-2 pb-2 pr-' +
            '4 pl-4',
        description: 'font-sans-roma text-center text-black text-15 mb-20 text-grey',
        componentBox: 'component-box w-full text-center',
        button: [
            'btn-primary font-sans-bold mb-15 text-center',
            'btn-secondary font-sans-bold text-center',
        ],
        buttonContainer: 'w-full',
    },
    ProdFeatureCard: {
        card: 'product-card text-center flex flex-col justify-around h-full ',
        mediaWrapper: '',
        cardMedia: 'w-full',
        contentWrapper: 'flex flex-col justify-end h-full',
        cardContent: 'px-2 py-1',
        cardActions: 'px-6 py-1',
        header: 'font-sans-bold block text-center text-black text-15 leading-normal pt-2 pb-2 pr-' +
            '4 pl-4',
        description: 'font-sans-roma text-center text-black text-15 mb-20 text-grey',
        componentBox: 'component-box w-full text-center',
        button: [
            'btn-primary font-sans-bold mb-15 text-center',
            'btn-secondary font-sans-bold text-center',
        ],
        buttonContainer: 'w-full',
    },
    'instagram-cards': {
        card: 'stacked-card flex flex-wrap md:flex md:justify-start w-full',
        mediaWrapper: 'flex flex-col w-full',
        cardMedia: 'justify-center min-h-1',
        contentWrapper: '',
        cardActions: 'px-6 py-1',
        header: 'title sm:text-18 md:text-20 font-BebasNeueRegular text-black pb-10 md:mt-20 sm:mt-20 text-lef',
        description: 'font-sans-roma leading-normal text-center text-black text-15 mb-20 text-grey mt-' +
            '10',
        componentBox: 'component-box w-full text-center',
        button: ['mb-15 btn btn-solid', ''],
        buttonContainer: 'w-full',
    },
    stillConfused: {
        card: '',
        containerWrapper: 'lg:w-innerContainer mx-auto font-HelveticaNeueLight mb-22 sm:text-18 lg:text-16 sm:px-20 lg:px-0 relative',
        sectionWrapper: 'md:flex',
        leftSection: 'w-full md:w-1/2',
        rightSection: 'w-full md:w-1/2 md:absolute right-0',
        mediaWrapper: 'flex items-center',
        cardMedia: 'md:w-370',
        contentWrapper: '',
        cardContent: '',
        cardActions: 'try-now-btn md:text-left md:w-1/2 pb-40 sm:pt-30 sm:pb-0',
        header: 'text-36 leading-48 text-black font-BornreadyRegular tracking-normal font-normal sm:mt-0 md:mt-100 mb-20 md:mb-30',
        description: 'md:text-16 leading-28 text-black font-HelveticaNeueLight tracking-normal md:mb-30 md:w-1/2 pr-20',
        componentBox: 'component-box w-full text-center',
        button: '',
        buttonContainer: 'w-full lg:text-left md:text-left sm:text-center',
    },
    hairBiologyCard: {
        card: 'hair-biology-card flex flex-wrap sm:text-center md:flex md:justify-start w-full relative px-0 md:mr-5 md:mt-5 sm:min-h-160 lg:min-h-auto sm:bg-whiteLighter overflow-hidden',
        mediaWrapper: 'flex flex-col w-full',
        cardMedia: 'justify-center min-h-1 w-full block z-9 md:z-0',
        contentWrapper: '',
        cardContent: 'flex-grow flex-no-shrink flex-basis absolute left-0 right-0 top-0',
        cardActions: 'px-6 py-1',
        header: 'font-BebasNeueBook block text-left text-black lg:text-27 lg:mt-134 lg:ml-65 leading-normal sm:m-30 sm:mb-0 sm:text-24 font-hairline',
        description: 'text-40 -ml-50 md:ml-0 lg:text-60 font-BornreadyRegular gradient-color leading-normal text-center text-black text-grey mx-auto -mt-15',
        componentBox: 'component-box w-full text-center',
        button: ['mb-15 btn btn-solid', ''],
        buttonContainer: 'w-full',
    },
    stackedCard: {
        card: 'stacked-card flex flex-wrap sm:text-center md:flex md:justify-start w-full',
        mediaWrapper: 'flex flex-col w-full md:px-15',
        cardMedia: 'justify-center min-h-1',
        contentWrapper: '',
        cardContent: 'flex-grow flex-no-shrink flex-basis ',
        cardActions: 'px-6 py-1',
        header: 'font-sans-bold block text-center text-black text-15 leading-normal pt-2 pb-2 pr-' +
            '4 pl-4',
        description: 'font-sans-roma leading-normal text-center text-black text-15 mb-20 text-grey mt-' +
            '10',
        componentBox: 'component-box w-full text-center',
        button: ['mb-15 btn btn-solid', ''],
        buttonContainer: 'w-full',
    },

    MindfullIngredients: {
        card: 'w-12/12 md:w-4/12 lg:w-4/12 stacked-card flex flex-wrap sm:text-center md:flex md:justify-start  w-full relative',
        mediaWrapper: 'flex flex-col w-full px-0',
        cardMedia: 'justify-center min-h-1',
        contentWrapper: '',
        cardContent: 'flex-grow flex-no-shrink flex-basis absolute block w-full text-center MindfullIngredientscontent',
        cardActions: 'px-6 py-1 absolute MindfullIngredientsbutton w-full',
        header: 'font-sans-bold block text-center text-black text-15  pt-2 pb-2 pr-' +
            '4 pl-4 font-BebasNeueBold text-9v md:text-3v leading-2v ',
        description: 'font-sans-roma leading-normal text-center text-black text-15 mb-20 text-grey mt-' +
            '10',
        componentBox: 'component-box w-full text-center',
        button: ['btn btn-solid border-solid border-2 text-darkyellow border-darkyellow text-1v py-3 px-28 md:py-2 md:px-17', ''],
        buttonContainer: 'w-full',
        subTitle: 'flex-grow font-BornreadyRegular text-3.5v',
        supportingText: 'supporting text text-center md:text-left md:w-8/12 mx-auto' 
    },
    OurselectiveIngredients: {
        card: 'w-12/12 md:w-4/12 lg:w-4/12 stacked-card flex flex-wrap sm:text-center md:flex md:justify-start md:pl-5  w-full relative',
        mediaWrapper: 'flex flex-col w-full px-0',
        cardMedia: 'justify-center min-h-1',
        contentWrapper: '',
        cardContent: 'flex-grow flex-no-shrink flex-basis absolute block w-full text-center OurselectiveIngredientscontent',
        cardActions: 'px-6 py-1 absolute OurselectiveIngredientsbutton w-full',
        header: 'font-sans-bold block text-center text-black text-15  pt-2 pb-2 pr-' +
            '4 pl-4 font-BebasNeueBold text-9v md:text-3v leading-2v  ',
        description: 'font-sans-roma leading-normal text-center text-black text-15 mb-20 text-grey mt-' +
            '10',
        componentBox: 'component-box w-full text-center',
        button: ['mb-15 btn btn-solid border-solid border-2 text-darkyellow border-darkyellow text-1v py-3 px-28 md:py-1 md:px-17', ''],
        buttonContainer: 'w-full',
        subTitle: 'flex-grow font-BornreadyRegular text-3.5v',


    },
    Nossosingredientes: {
        card: 'w-12/12 md:w-4/12 lg:w-4/12  stacked-card flex flex-wrap sm:text-center md:flex md:justify-start md:pl-5  w-full relative ',
        mediaWrapper: 'flex flex-col w-full px-0',
        cardMedia: 'justify-center min-h-1',
        contentWrapper: '',
        cardContent: 'flex-grow flex-no-shrink flex-basis md:w-60p absolute block w-full text-center Nossosingredientescontent',
        cardActions: 'px-6 py-1 absolute Nossosingredientesbutton w-full',
        header: 'font-sans-bold block text-center text-black text-15 pt-2 pb-2 pr-' +
            '4 pl-4 font-BebasNeueBold text-9v md:text-3v leading-2.5v',
        description: 'font-sans-roma leading-normal text-center text-black text-15 mb-20 text-grey mt-' +
            '10',
        componentBox: 'component-box w-full text-center',
        button: ['mb-15 btn btn-solid border-solid border-2 text-darkyellow border-darkyellow text-1v py-3 px-28 md:py-1 md:px-17', ''],
        buttonContainer: 'w-full',
        subTitle: 'flex-grow font-BornreadyRegular text-3.5v ',
      

    },
    ListadeIngredientes: {
        card: 'w-12/12 md:w-4/12 lg:w-4/12  stacked-card flex flex-wrap sm:text-center md:flex md:justify-start md:pl-5 w-full relative',
        mediaWrapper: 'flex flex-col w-full px-0',
        cardMedia: 'justify-center min-h-1',
        contentWrapper: '',
        cardContent: 'flex-grow flex-no-shrink flex-basis absolute block w-full text-center ListadeIngredientescontent',
        cardActions: 'px-6 py-1 absolute ListadeIngredientesbutton w-full',
        header: 'font-sans-bold block text-center text-black text-15  pt-2 pb-2 pr-' +
            '4 pl-4 font-BebasNeueBold text-9v md:text-3v leading-2.5v',
        description: 'font-sans-roma leading-normal text-center text-black text-15 mb-20 text-grey mt-' +
            '10',
        componentBox: 'component-box w-full text-center',
        button: ['mb-15 btn btn-solid border-solid border-2 text-darkyellow border-darkyellow text-1v py-3 px-28 md:py-1 md:px-17', ''],
        buttonContainer: 'w-full',
        subTitle: 'flex-grow font-BornreadyRegular text-3.5v',
       

    },

    storyStackedCard: {
        card: 'stacked-card5 flex flex-wrap sm:text-center md:flex md:justify-start w-full',
        mediaWrapper: 'flex flex-col w-full md:px-15',
        cardMedia: 'justify-center min-h-1',
        contentWrapper: '',
        cardContent: 'flex-grow flex-no-shrink flex-basis ',
        cardActions: 'px-6 py-1',
        header: 'font-sans-bold block text-center text-black text-13 pt-2 pb-2 pr-' +
            '4 pl-4',
        description: 'font-sans-roma leading-normal text-center text-black text-13 mb-20 text-grey mt-' +
            '10',
        componentBox: 'component-box w-full text-center',
        button: ['mb-15 btn btn-solid', ''],
        buttonContainer: 'w-full',
    },
    seriesCard: {
        cardWrapper: 'mb-3 md:mb-0 border-r border-b border-white pb-20 relative',
        cardContent: 'px-15',
        cardMedia: 'w-full',
        mediaHorizontal: 'w-1/2',
        cardHeader: 'font-normal text-2xl lg:text-4xl leading-normal text-black-lighter',
        cardDescription: 'font-sans-roma text-s13-m13-l15 pb-2 text-black-lighter',
        cardButton: 'btn btn-solid font-sans-bold text-13',
        cardActions: 'absolute -translate-y50 pr-15 pl-2 pin-t50 right-0 w-6/12',
        actionContent: 'font-sans-bold text-4xl mb-20 text-black-lighter',
        styleVariant: {
            'Series-Gold-Medium': 'bg-gr-gold-medium',
            'Series-Grey-Medium': 'bg-gr-grey-medium',
            'Series-Grey-Light': 'bg-gr-grey-light',
            'Series-Blue-Dark': 'bg-gr-blue-dark',
            'Series-Blue-Medium': 'bg-gr-blue-medium',
            'Series-Blue-Light': 'bg-gr-blue-light',
            'Series-Teal-Medium': 'bg-gr-teal-medium',
        },
        button: ['', ''],
    },
    seriesFeatureCard: {
        mainWrapper: 'px-15 mb-15 md:mb-30',
        cardWrapper: 'bg-grey-lighter py-20 md:py-40 series-feature-card',
        cardContent: 'text-center md:text-left md:ml-20 md:lg-30 cta-section',
        contentCenter: 'text-center',
        cardMedia: 'w-full max-w-full pb-15',
        mediaHorizontal: 'w-1/2',
        cardHeader: 'font-sans font-normal text-black mb-10 text-4xl lg:text-7xl leading-23',
        cardDescription: 'font-sans-roma text-s13-m13-l15 text-black',
        cardButton: 'btn btn-solid',
        actionContent: 'font-sans-bold text-base leading-normal text-black ml-15 inline-block',
        button: ['', ''],
    },
    StackedImage: {
        card: 'stacked-image-text flex flex-wrap text-center md:flex md:justify-start w-full',
        mediaWrapper: 'flex flex-col w-full md:px-15',
        cardMedia: 'justify-center min-h-1',
        contentWrapper: '',
        cardContent: 'flex-grow flex-no-shrink flex-basis ',
        description: 'font-sans-roma text-center text-black text-s13-m13-l15 mb-20 mt-10',
        componentBox: 'component-box w-full text-center',
        button: ['mb-15 btn btn-solid', ''],
        buttonContainer: 'w-full',
    },
    StackedDefault: {
        card: 'primary-card flex flex-wrap',
        mediaWrapper: 'flex flex-col w-full bg-white',
        cardMedia: 'w-full min-h-1',
        contentWrapper: 'h-full',
        cardContent: 'flex-grow flex-no-shrink flex-basis px-20',
        cardActions: 'px-20 pb-30',
        header: 'font-sans-bold text-black text-s13-m15-l15 mt-20 md:mt-4 sm:mb-2 md:mb-10',
        description: 'font-sans-light text-black text-s18-m20-l24 mb-25 md:mb-20',
        componentBox: 'component-box w-full',
        button: ['btn btn-solid', ''],
        buttonContainer: 'w-full',
    },
    StackedDefaultGreyBG: {
        card: 'primary-card flex flex-wrap',
        mediaWrapper: 'flex flex-col w-full bg-grey-lighter',
        cardMedia: 'w-full min-h-1',
        contentWrapper: 'h-full',
        cardContent: 'flex-grow flex-no-shrink flex-basis px-20',
        cardActions: 'px-20 pb-30',
        header: 'font-sans-bold text-black text-s13-m15-l15 mt-20 md:mt-4 sm:mb-2 md:mb-10',
        description: 'font-sans-light text-black text-s18-m20-l24 mb-25 md:mb-20',
        componentBox: 'component-box w-full',
        button: ['btn btn-solid', ''],
        buttonContainer: 'w-full',
    },
    StackedBasic: {
        card: 'primary-card-without-padding  flex flex-wrap',
        mediaWrapper: 'flex flex-col w-full bg-white',
        cardMedia: 'w-full min-h-1',
        contentWrapper: 'h-full',
        cardContent: 'flex-grow flex-no-shrink flex-basis',
        cardActions: '',
        header: 'font-sans-bold text-black text-s13-m15-l15 mt-20 sm:mb-5 md:mb-10',
        description: 'font-sans-light text-black text-s18-m20-l24 my-20',
        componentBox: 'component-box w-full',
        button: ['btn btn-solid', ''],
        buttonContainer: 'w-full',
    },
    StackedShopNow: {
        card: 'secondary-card flex flex-wrap',
        mediaWrapper: 'flex flex-col w-full bg-white',
        cardMedia: 'w-full min-h-1',
        contentWrapper: 'h-full',
        cardContent: 'flex-grow flex-no-shrink flex-basis px-20',
        cardActions: 'px-20 pb-30',
        header: 'font-sans-bold text-black text-s13-m15-l15 mt-20 md:mt-4 sm:mb-2 md:mb-10',
        description: 'font-sans-light text-black text-s18-m20-l24 mb-25 md:mb-20',
        componentBox: 'component-box w-full',
        button: ['btn btn-secondary', ''],
        buttonContainer: 'w-full',
    },
    StackedCenter: {
        card: 'simple-card',
        mediaWrapper: '',
        cardMedia: 'w-full',
        contentWrapper: '',
        cardContent: 'py-1 pb-20 md:pb-0',
        header: 'font-sans-light text-s18-m20-l24 text-black text-center mt-20 mb-10',
        description: 'font-sans-roma text-s13-m13-l15 text-black text-center mb-10 md:px-15',
        componentBox: 'component-box w-full',
        button: ['', ''],
    },
    StackedCenterArticle: {
        card: 'simple-card-para',
        mediaWrapper: '',
        cardMedia: 'w-full',
        contentWrapper: '',
        cardContent: 'py-1 pb-20 md:pb-0',
        description: 'font-sans-roma text-s13-m13-l15 text-black text-center mb-10 md:px-15 pt-15',
        componentBox: 'component-box w-full',
        button: ['', ''],
    },
    VideoCenter: {
        card: 'promo-card',
        mediaWrapper: 'w-full',
        cardMedia: 'w-full',
        contentWrapper: '',
        cardContent: 'px-2 text-center',
        header: 'font-sans text-s18-m20-l24 text-black text-center mt-4 mb-10',
        componentBox: 'component-box w-full',
        button: ['font-sans-bold text-black mt-15', ''],
        buttonContainer: 'w-full',
        cardActions: 'flex justify-center',
    },
    ShelfCarousel: {
        card: 'card multi-button-carousel-card text-center pb-30',
        mediaWrapper: 'w-full',
        cardMedia: 'max-w-full',
        cardContent: '',
        contentWrapper: 'w-full mt-20 button-contain',
        heading: 'font-sans-bold text-s13-m13-l15- text-lg leading-23 text-black mb-5 shelf-heading',
        description: 'font-sans-roma font-normal text-black-lighter text-base leading-20 shelf-desc',
        buttonContainer: 'w-full',
        button: ['btn btn-solid', 'btn btn-secondary mt-15'],
    },
    ShelfDefault: {
        card: 'card multi-button-card flex flex-col text-center md:border-r border-grey-light',
        mediaWrapper: 'flex-grow flex-no-shrink flex-basis w-full',
        cardMedia: 'max-w-full',
        contentWrapper: 'px-15 w-full mt-20 pb-30 md:pb-0 button-contain',
        heading: 'font-sans-bold text-lg leading-23 text-black',
        description: 'px-15 font-sans-roma font-normal text-lg leading-23 text-grey-dark',
        buttonContainer: 'w-full',
        button: ['btn btn-solid', 'btn btn-secondary mt-15'],
    },
    Shelfprodfeature: {
        card: 'card multi-button-card flex flex-col text-center',
        mediaWrapper: 'flex-grow flex-no-shrink flex-basis w-full border-grey-light border rounded pt-25 leading-zero',
        cardMedia: 'max-w-full',
        contentWrapper: 'px-15 w-full mt-20 mb-30 button-contain',

        heading: 'font-sans-bold text-s21-m24-l26 text-black',
        description: 'px-15 font-sans-roma font-normal text-13 pt-15 text-black',
        buttonContainer: 'w-full',
        button: ['btn btn-amber', 'btn btn-secondary mt-15'],
    },
    Shelfprodfeatureml16: {
        card: 'card multi-button-card flex flex-col text-center md:ml-15%',
        mediaWrapper: 'flex-grow flex-no-shrink flex-basis w-full border-grey-light border rounded pt-25 leading-zero',
        cardMedia: 'max-w-full',
        contentWrapper: 'px-15 w-full mt-20 mb-30 button-contain',

        heading: 'font-sans-bold text-s21-m24-l26 text-black',
        description: 'px-15 font-sans-roma font-normal text-13 pt-15 text-black',
        buttonContainer: 'w-full',
        button: ['btn btn-amber', 'btn btn-secondary mt-15'],
    },

    ShelfLanding: {
        card: 'card multi-button-landing-card flex flex-col text-center border-b pb-30 md:pb-0 md:border-b-0 md:border-r border-grey-light',
        mediaWrapper: 'flex-grow flex-no-shrink flex-basis w-full',
        cardMedia: 'max-w-full',
        contentWrapper: 'w-full mt-20',
        heading: 'font-sans-bold text-lg leading-19 lg:leading-23 text-black mb-10 mt-20',
        description: 'font-sans-roma font-normal text-lg leading-19 md:leading-23 text-grey-dark',
        buttonContainer: 'w-full',
        button: ['btn btn-solid', 'btn btn-secondary mt-15'],
    },

    ShelfLandingwithoutborder: {
        card: 'card multi-button-landing-card flex flex-col text-center border-b py-30 md:py-0 md:border-b-0  border-grey-light',
        mediaWrapper: 'flex-grow flex-no-shrink flex-basis w-full',
        cardMedia: 'max-w-full',
        contentWrapper: 'w-full mt-20',
        heading: 'font-sans-bold text-2xl leading-19 lg:leading-23 text-black mb-10 mt-20',
        description: 'font-sans-roma font-normal text-lg leading-19 md:leading-23 text-black',
        buttonContainer: 'w-full',
        button: ['btn btn-amber', 'btn btn-prodcompare mt-15'],
    },
    ShelfShopNow: {
        card: 'card details-shop-card text-center',
        mediaWrapper: 'w-full',
        cardMedia: 'max-w-full',
        contentWrapper: 'w-full mt-20',
        heading: 'font-sans-bold text-s13-m13-l15 text-black mb-10',
        description: 'font-sans-roma font-normal text-s13-m13-l15 text-grey-dark',
        buttonContainer: 'w-full mt-20',
        button: ['btn btn-secondary'],
    },

    ShelfShopNownewart: {
        card: 'card details-shop-card text-center',
        mediaWrapper: 'w-full',
        cardMedia: 'max-w-full',
        contentWrapper: 'w-full mt-20',
        heading: 'font-sans-bold text-s13-m13-l15 text-black mb-10 md:mb-0',
        description: 'font-sans-roma font-normal text-s13-m13-l15 text-grey-dark',
        buttonContainer: 'w-full mt-20 md:mt-15',
        button: ['btn btn-amber', ''],
    },
    ShelfCarouselShopNow: {
        card: 'card carousel-shop-card flex flex-col text-center',
        mediaWrapper: 'flex-grow flex-no-shrink flex-basis w-full',
        cardMedia: 'max-w-full',
        contentWrapper: 'px-15 w-full mt-20 md:mt-0 border-b pb-30 border-grey-light md:border-none md:pb-0',
        heading: 'font-sans-bold text-lg leading-23 text-black px-3 py-5',
        description: 'px-15 font-sans-roma font-normal text-lg leading-23 text-grey-dark',
        buttonContainer: 'w-full button-contain',
        button: ['btn btn-secondary', ''],
    },
    ShelfCompare: {
        card: 'card details-compare-card text-center pb-40 lg:pb-0',
        mediaWrapper: 'w-full',
        cardMedia: 'max-w-full mb-20',
        contentWrapper: 'w-full mt-20',
        heading: 'font-sans-bold text-s13-m13-l15 text-black mb-10',
        description: 'font-sans-roma text-s13-m13-l15 text-black',
        buttonContainer: 'w-full mt-20',
        button: ['btn btn-primary btn-compare ', ''],
    },

    ShelfComparepb40: {
        card: 'card details-compare-card text-center pb-40',
        mediaWrapper: 'w-full',
        cardMedia: 'max-w-full mb-20',
        contentWrapper: 'w-full mt-20',
        heading: 'font-sans-bold text-s13-m13-l15 text-black mb-10',
        description: 'font-sans-roma text-s13-m13-l15 text-black',
        buttonContainer: 'w-full mt-20',
        button: ['btn btn-primary btn-compare ', ''],
    },

    horizontalCard: {
        card: 'horizontal-card flex flex-row flex-wrap md:px-15',
        cardTitle: 'my-10 md:mb-10',
        mediaWrapper: 'sm:w-full text-center md:w-4/12 px-15 md:content-center md:float-left pt-10 md:pt-0',
        cardMedia: ' w-30 md:w-full md:text-center',
        contentWrapper: 'sm:w-full md:w-8/12 md:px-15 md:pt-0 md:float-right',
        cardContent: 'w-full  md:px-0 text-s13-m13-l15',
        cardActions: 'w-full  md:px-0 ',
        cardText: ' md:mb-10',
        button: ['', ''],
    },
    savewaterHoriziontalCard:{
        card: ' relative horizontal-card md:lex md:flex-col bg-white  flex-wrap md:mr-1p md:px-15 savewaterHoriziontalCardcontainer',
        cardTitle: 'my-10 md:mb-10',
        mediaWrapper: 'sm:w-full text-center  md:mx-auto md:px-0 md:content-center  pt-10 md:pt-4p',
        cardMedia: ' w-30 md:w-full md:text-center',
        contentWrapper: 'sm:w-full md:mx-0 md:px-0 md:pt-0 md:py-4p',
        cardContent: 'w-full  md:w-86p md:mx-auto md:px-0 md:pt-6p savewaterHoriziontalCardinnercontainer',
        cardActions: 'w-full  md:px-0 ',
        cardText: ' font-BebasNeueRegular font-semibold text-center text-1.2v md:mb-10',
        button: ['', ''],
    },
    homehorizontalCard: {
        card: 'horizontal-card md:flex flex-row flex-wrap justify-center sm:float-left sm:w-1/2 sm:p-8 md:p-0',
        cardTitle: 'my-10 md:mb-10',
        mediaWrapper: 'sm:w-full text-center md:w-12/12 md:content-center md:float-left sm:pt-0 pt-10 md:pt-0 lg:max-w-163 p-5',
        cardMedia: ' w-30 md:w-full md:text-center',
        contentWrapper: 'sm:w-full md:w-8/12 md:px-15 md:pt-0 md:float-right',
        cardContent: 'w-full  md:px-0 text-s13-m13-l15',
        cardActions: 'w-full  md:px-0 ',
        cardText: ' md:mb-10',
        button: ['', ''],
    },
    'hair-gender-card': {
        card: 'hair-gender-card flex flex-row flex-wrap relative mr-30',
        cardTitle: 'my-10 md:mb-10',
        mediaWrapper: 'sm:w-full text-center md:content-center pt-10 md:pt-0',
        cardMedia: ' w-30 md:w-full md:text-center',
        contentWrapper: 'contentWrapper bg-white w-90p mx-auto text-center -mt-90 p-15',
        cardContent: 'w-full  md:px-0 text-s13-m13-l15 text-black',
        cardActions: 'w-full  md:px-0 ',
        cardText: ' md:mb-10',
        button: ['', ''],
    },
    'ingredients-card': {
        card: 'flex flex-row flex-wrap items-center mb-22',
        cardTitle: '',
        mediaWrapper: 'overflow-hidden w-48 h-48 rounded-full border-2 border-golden-light border-solid',
        cardMedia: 'bg-transparent ingredient-image-gradient bg-left-top bg-no-repeat',
        contentWrapper: 'w-6/12 flex pl-20 text-18 md:text-16 md:leading-24 font-HelveticaNeueLight tracking-normal text-black',
        cardContent: '',
        cardActions: 'ml-50',
        cardText: ' md:mb-10',
        button: ['', ''],
    },
    'stands-for-card': {
        card: 'flex flex-row items-center mb-22',
        cardTitle: '',
        mediaWrapper: 'w-48 h-48',
        cardMedia: '',
        contentWrapper: 'w-10/12 flex pl-20 text-18 md:text-16 md:leading-20 font-HelveticaNeueLight tracking-normal text-black',
        cardContent: '',
        cardActions: 'ml-50',
        cardText: ' md:mb-10',
        button: ['', ''],
    },
    horizontalReverseCard: {
        card: 'horizontal-reverse-card flex  md:flex-row md:flex-row-reverse flex-wrap md:px-15',
        cardTitle: 'my-10 md:mb-10',
        mediaWrapper: 'sm:w-full text-center md:w-4/12 md:content-center md:float-left',
        cardMedia: 'pt-10 md:pt-0 px-15 md:w-full md:text-center',
        contentWrapper: 'sm:w-full md:w-8/12 md:px-15 md:pt-0 md:float-right',
        cardContent: 'w-full  md:px-0 text-s13-m13-l15',
        cardActions: 'w-full  md:px-0 ',
        cardText: ' md:mb-10',
        button: ['', ''],
    },
    horizontalReverseCardLarge: {
        card: 'horizontal-reverse-card horizontal-reverse-large flex  md:flex-row md:flex-row-reverse flex-wrap md:px-15',
        cardTitle: 'mb-10 md:mb-20 text-s21-m36-l48 font-sans',
        mediaWrapper: 'sm:w-full text-center md:w-6/12 md:content-center md:float-left',
        cardMedia: 'pt-10 md:pt-0 px-15 md:w-full md:text-center',
        contentWrapper: 'sm:w-full md:w-6/12 md:px-15 md:pt-0 md:float-right',
        cardContent: 'w-full  md:px-0 card-text font-sans-roma text-s13-m13-l15 text-black',
        cardActions: 'w-full  md:px-0 ',
        cardText: ' md:mb-10',
        button: ['', ''],
    },

    editorialCard: {
        card: 'editorial-card flex flex-row flex-wrap md:px-15',
        cardTitle: 'my-10 md:mb-10',
        mediaWrapper: 'sm:w-full text-center md:w-4/12 px-15 md:content-center md:float-right ',
        cardMedia: ' w-30 md:w-full md:text-center pt-10 md:pt-0',
        contentWrapper: 'sm:w-full md:w-8/12 md:px-15 md:pt-0 md:float-left',
        cardContent: 'w-full  md:px-0 text-s13-m13-l15',
        cardActions: 'w-full  md:px-0 ',
        cardText: ' md:mb-10',
        button: ['', ''],
    },
    articleEditorialCard: {
        card: 'editorial-card flex flex-row flex-wrap',
        cardTitle: 'mb-15 text-s20-m30-l36 font-sans',
        mediaWrapper: 'sm:w-full text-center md:w-4/12 pt-25 md:pt-0 md:pl-20 md:content-center',
        cardMedia: 'md:pt-0 md:w-full md:text-center',
        contentWrapper: 'sm:w-full md:w-8/12 md:pr-10 md:pt-0 self-center',
        cardContent: 'w-full md:px-0 text-s13-m13-l15',
        cardActions: 'w-full md:px-0 ',
        cardText: 'font-sans-roma',
        button: ['', ''],
    },
    articleEditorialCardReverse: {
        card: 'editorial-card flex md:flex-row md:flex-row-reverse flex-wrap items-center pb-4',
        cardTitle: 'md:mt-15 md:mb-5 text-2xl lg:text-5xl leading-25 lg:leading-34 font-sans',
        mediaWrapper: 'sm:w-full text-center md:w-4/12 pt-20 md:pt-0 md:content-center md:pr-20',
        cardMedia: 'md:pt-0 md:w-full md:text-center',
        contentWrapper: 'sm:w-full md:w-8/12 md:pl-10',
        cardContent: 'w-full md:px-0 text-s13-m13-l15',
        cardActions: 'w-full pt-2',
        cardText: 'font-sans text-s18-m20-l24 lg:text-5xl mb-3',
        button: ['', ''],
    },
    articleEditorialEqualHalvesCard: {
        card: 'editorial-card flex flex-row flex-wrap',
        cardTitle: 'mb-15 text-s18-m20-l24 font-sans',
        mediaWrapper: 'sm:w-full text-center md:w-6/12 pt-25 md:pt-0 md:pl-20 md:content-center',
        cardMedia: 'md:pt-0 md:w-full md:text-center',
        contentWrapper: 'sm:w-full md:w-6/12 md:pr-10 md:pt-0 self-center',
        cardContent: 'w-full md:px-0 text-s13-m13-l15',
        cardActions: 'w-full md:px-0 ',
        cardText: 'font-sans-roma',
        button: ['', ''],
    },
    articlePromoEditorialCard: {
        card: 'editorial-card flex flex-row flex-wrap',
        cardTitle: 'text-s18-m20-l24 lg:text-5xl mb-3 font-sans',
        mediaWrapper: 'sm:w-full text-center md:w-4/12 md:pl-20 md:content-center',
        cardMedia: 'md:pt-0 md:w-full md:text-center',
        contentWrapper: 'sm:w-full md:w-8/12 md:pr-10 md:pt-0 self-center',
        cardContent: 'w-full md:px-0 text-s13-m13-l15',
        cardActions: 'w-full pt-25 pb-5',
        cardText: 'text-s13-m13-l15 pt-15 font-sans-roma',
        button: ['', ''],
    },
    articlePromoEditorialCardReverse: {
        card: 'editorial-card flex md:flex-row md:flex-row-reverse flex-wrap',
        cardTitle: 'text-s18-m20-l24 lg:text-5xl mb-3 font-sans',
        mediaWrapper: 'sm:w-full text-center md:w-4/12 md:pr-20 md:content-center',
        cardMedia: 'md:pt-0 md:w-full md:text-center',
        contentWrapper: 'sm:w-full md:w-8/12 md:pl-10 md:pt-0 self-center',
        cardContent: 'w-full md:px-0 text-s13-m13-l15',
        cardActions: 'w-full pt-25 pb-5',
        cardText: 'text-s13-m13-l15 pt-15 font-sans-roma',
        button: ['', ''],
    },

    articlePromoEditorialCardReversenweart: {
        card: 'editorial-card flex md:flex-row md:flex-row-reverse flex-wrap',
        cardTitle: 'text-s18-m20-l24 lg:text-5xl mb-3 font-sans',
        mediaWrapper: 'sm:w-full text-center md:w-4/12 md:pr-20 pb-10 md:pb-0 md:content-center',
        cardMedia: 'md:pt-0 md:w-full md:text-center',
        contentWrapper: 'sm:w-full md:w-8/12 md:pl-10 md:pt-0 self-center pb-20 md:pb-0',
        cardContent: 'w-full md:px-0 text-s13-m13-l15',
        cardActions: 'w-full pt-25',
        cardText: 'text-s13-m13-l15 pt-0 font-sans-roma',
        button: ['', ''],
    },

    storyHorizontalCard: {
        card: 'editorial-card flex flex-row flex-wrap md:px-15 items-center',
        cardTitle: 'mb-10 md:mb-20 text-s21-m36-l48 ',
        mediaWrapper: 'sm:w-full text-center md:w-6/12 md:pr-15 md:content-center pb-30 md:pb-0',
        cardMedia: 'w-full pt-10 md:pt-0 md:w-full md:text-center',
        contentWrapper: 'sm:w-full md:w-6/12 md:pl-15 md:pt-0 relative mb-10 md:mb-0',
        cardContent: 'w-full  md:pr-15 text-s13-m13-l15  border-b pb-30 md:border-b-0 md:pb-0',
        cardActions: 'w-full md:px-0 pt-20 md:pt-0 mb-10 md:mb-0',
        cardText: 'md:mb-20 font-sans-roma',
        button: ['', ''],
    },
    storyEditorialCard: {
        card: 'editorial-card flex flex-row flex-wrap md:px-15 items-center',
        cardTitle: 'mb-10 md:mb-20 text-s21-m36-l48 ',
        mediaWrapper: 'sm:w-full text-center md:w-6/12 md:pl-15 md:content-center md:float-right pb-30 md:pb-0',
        cardMedia: 'w-full pt-10 md:pt-0 md:w-full md:text-center',
        contentWrapper: 'sm:w-full md:w-6/12 md:pr-15 md:pt-0 md:float-left relative mb-10 md:mb-0',
        cardContent: 'w-full  text-s13-m13-l15',
        cardActions: 'w-full md:px-0 pt-20 md:pt-0 mb-10 md:mb-0',
        cardText: ' mb-10 md:mb-20 font-sans-roma',
        button: ['', ''],
    },
    storyEditorialCardReverse: {
        card: 'editorial-card flex flex-row flex-row-reverse flex-wrap md:px-15 items-center',
        cardTitle: 'mb-10 md:mb-20 text-s21-m36-l48 ',
        mediaWrapper: 'sm:w-full text-center md:w-6/12 md:pr-15 md:content-center md:float-left pb-30 md:pb-0',
        cardMedia: ' w-full pt-10 md:pt-0 md:w-full md:text-center',
        contentWrapper: 'sm:w-full md:w-6/12 md:px-15 md:pt-0 md:float-right relative',
        cardContent: 'w-full  md:px-0 text-s13-m13-l15 mb-20 md:mb-0',
        cardActions: 'w-full  md:px-0 ',
        cardText: ' md:mb-10 font-sans-roma',
        button: ['', ''],
    },
    storyEditorialCardReverse7colRight: {
        card: 'editorial-card flex flex-row flex-row-reverse flex-wrap md:px-15 items-center',
        cardTitle: 'mb-10 md:mb-20 text-s21-m36-l48 ',
        mediaWrapper: 'sm:w-full text-center md:w-5/12 md:pr-15 md:content-center md:float-left pb-30 md:pb-0',
        cardMedia: ' w-full pt-10 md:pt-0 md:w-full md:text-center',
        contentWrapper: 'sm:w-full md:w-7/12 md:px-15 md:pt-0 md:float-right relative',
        cardContent: 'w-full  md:px-0 text-s13-m13-l15 mb-20 md:mb-0',
        cardActions: 'w-full  md:px-0 ',
        cardText: ' md:mb-10 font-sans-roma',
        button: ['', ''],
    },
    storyEditorialCardReverseWideRight: {
        card: 'editorial-card flex flex-row flex-row-reverse flex-wrap md:px-15 items-center',
        cardTitle: 'md:mb-10 md:mb-20 text-s21-m36-l48 ',
        mediaWrapper: 'sm:w-full text-center md:w-4/12 md:pr-15 md:content-center md:float-left pb-30 md:pb-0',
        cardMedia: ' w-full pt-10 md:pt-0 md:w-full md:text-center',
        contentWrapper: 'sm:w-full md:w-8/12 md:px-15 md:pt-0 md:float-right relative',
        cardContent: 'w-full  md:px-0 text-s13-m13-l15',
        cardActions: 'w-full  md:px-0 ',
        cardText: ' md:mb-10 font-sans-roma',
        button: ['', ''],
    },
    storyEditorialCardWideLeft: {
        card: 'editorial-card flex flex-row flex-wrap md:px-15',
        cardTitle: 'my-10 md:mb-20 text-s21-m36-l48 ',
        mediaWrapper: 'sm:w-full text-center md:w-4/12 px-15 md:content-center pb-30 md:pb-0',
        cardMedia: ' w-full pt-10 md:pt-0 md:w-full md:text-center',
        contentWrapper: 'sm:w-full md:w-8/12 md:px-15 md:pt-0 relative',
        cardContent: 'w-full  md:px-0 text-s13-m13-l15 md:absolute md:inset-x-0 md:-translate-y50 pin-t50',
        cardActions: 'w-full  md:px-0 ',
        cardText: ' md:mb-10 font-sans-roma',
        button: ['', ''],
    },
    sensitiveSkinEditorialWideRight: {
        card: 'editorial-card flex flex-row flex-row-reverse flex-wrap md:px-15 items-center',
        cardTitle: 'mb-15 md:mb-25 text-s18-m30-l36 md:ml-10',
        mediaWrapper: 'sm:w-full text-center md:w-4/12 md:pr-15 md:content-center md:float-left pb-30 md:pb-0',
        cardMedia: 'w-full pt-25 md:pt-0 md:w-full md:text-center',
        contentWrapper: 'sm:w-full md:w-8/12 md:px-15 md:pt-0 md:float-right relative',
        cardContent: 'w-full md:px-0 text-s13-m13-l15',
        cardActions: 'w-full md:px-0',
        cardText: 'mb-20 md:mb-30 font-sans-roma md:ml-10',
        button: ['', ''],
    },
    sensitiveSkinEditorialWideLeft: {
        card: 'editorial-card flex flex-row flex-wrap md:px-15',
        cardTitle: 'mb-15 md:mb-25 text-s18-m30-l36 md:mr-10',
        mediaWrapper: 'sm:w-full text-center md:w-4/12 px-15 md:pl-15 md:pr-0 md:content-center pb-30 md:pb-0',
        cardMedia: 'w-full pt-25 md:pt-0 md:w-full md:text-center',
        contentWrapper: 'sm:w-full md:w-8/12 md:px-15 md:pt-0 relative',
        cardContent: 'w-full  md:px-0 text-s13-m13-l15 md:absolute md:inset-x-0 md:-translate-y50 pin-t50',
        cardActions: 'w-full  md:px-0 ',
        cardText: 'mb-20 md:mb-30 font-sans-roma md:mr-10',
        button: ['', ''],
    },
    storyEditorialCardFullWidth: {
        card: 'editorial-card flex flex-row flex-wrap md:px-15',
        cardTitle: 'mb-10 md:mb-20 text-s18-m20-l24 font-sans-light',
        mediaWrapper: 'w-full text-center content-center',
        cardMedia: 'w-full md:text-center',
        contentWrapper: 'w-full md:pt-0 md:float-left mb-30 md:mb-60',
        cardContent: 'w-full  md:px-0 text-s13-m13-l15 text-center font-sans-roma',
        cardActions: 'w-full  md:px-0 ',
        cardText: ' md:mb-10',
        button: ['', ''],
    },
    spotlightStacked: {
        card: 'simple-card text-center mb-20 md:mb-40',
        mediaWrapper: '',
        cardMedia: 'w-auto h-80 lg:h-100 mx-auto',
        contentWrapper: '',
        cardContent: 'px-2 py-1',
        header: 'font-sans-bold text-s13-m13-l15 text-black mt-15',
        description: 'font-sans-roma text-s13-m13-l15 text-black',
        componentBox: 'component-box w-full',
        button: ['', ''],
    },
    storyStackedCenter: {
        card: 'story-stacked-card',
        mediaWrapper: 'media wrapper',
        cardMedia: 'w-auto h-80 lg:h-100 mx-auto text-center mb-20',
        contentWrapper: '',
        cardContent: 'mb-30 md:mb-0',
        header: 'font-sans-light text-s13-m13-l15 text-black mb-10 lg:mb-0 text-center',
        description: 'font-sans-roma text-s13-m13-l15 text-black text-center',
        componentBox: 'component-box w-full',
        button: ['', ''],
    },
    promotionStackedCenter: {
        card: 'promo-stacked-card',
        mediaWrapper: 'media wrapper mx-30',
        cardMedia: 'w-auto h-80 lg:h-100 mx-auto text-center mb-20',
        contentWrapper: '',
        cardContent: 'mb-30 md:mb-0',
        header: 'font-sans-roma text-s13-m13-l15 text-black mb-10 lg:mb-0 text-center',
        description: 'font-sans-roma text-s13-m13-l15 text-black text-center',
        componentBox: 'component-box w-full',
        button: ['', ''],
    },

    replacementStackedCards: {
        card: 'stacked-card flex flex-wrap sm:text-center md:flex md:justify-start w-full bg-no-repeat replacement-stacked-card md:mb-15',
        mediaWrapper: 'flex flex-col w-full',
        cardMedia: 'justify-center min-h-1 md:pb-10',
        contentWrapper: '',
        cardContent: 'flex-grow flex-no-shrink flex-basis ',
        cardActions: 'px-6 py-1',
        header: 'font-sans-roma leading-normal text-center text-grey-dark text-15 px-15',
        description: 'font-sans-roma leading-normal text-center text-black text-15 mb-20 text-grey mt-' +
            '10',
        componentBox: 'component-box w-full text-center',
        button: ['mb-15 btn btn-solid', ''],
        buttonContainer: 'w-full',
    },

    'storyEditorialCardReverse-ln': {
        card: 'editorial-card flex md:flex-row sm:flex-col-reverse md:flex-row-reverse flex-wrap md:px-15 items-center sm:w-10/12 sm:m-auto',
        cardTitle: 'mb-10 md:mb-20 text-s21-m36-l48 md:text-5xl md:leading-tight  md:w-6/12 md:m-auto bg-black rounded text-white p-20 ',
        mediaWrapper: 'sm:w-full text-center md:w-6/12 md:pr-15 md:content-center md:float-left pb-30 md:pb-0',
        cardMedia: ' w-full pt-10 md:pt-0 md:w-full md:text-center',
        contentWrapper: ' md:w-6/12 md:px-15 md:pt-0 md:float-right relative',
        cardContent: 'w-full  md:px-0 text-s13-m13-l15 mb-20 md:mb-0',
        cardActions: 'w-full  md:px-0 ',
        cardText: ' md:mb-10 font-sans-roma md:w-6/12 md:m-auto sm:mb-20',
        button: ['', ''],
    },

    'storyEditorialCard-ln': {
        card: 'editorial-card flex md:flex-row sm:flex-col-reverse md:flex-wrap md:px-15 items-center sm:w-10/12 sm:m-auto ',
        cardTitle: 'mb-10 md:mb-20 text-s21-m36-l48 md:text-4xl md:leading-tight  md:w-6/12 md:m-auto bg-black rounded text-white p-20 ',
        mediaWrapper: 'sm:w-full text-center md:w-6/12 md:pl-15 md:content-center md:float-right pb-30 md:pb-0',
        cardMedia: 'w-full pt-10 md:pt-0 md:w-full md:text-center',
        contentWrapper: ' md:w-6/12 md:pr-15  md:pt-0 md:float-left relative',
        cardContent: 'w-full  text-s13-m13-l15',
        cardActions: 'w-full md:px-0 pt-20 md:pt-0 mb-10 md:mb-0',
        cardText: '  md:mb-10 font-sans-roma md:w-6/12 md:m-auto sm:mb-20',
        button: ['', ''],
    },

    ShelfDefaultProductln: {
        card: 'card multi-button-card flex flex-col text-center md:border-0 md:w-3/12 m-auto items-center md:w-3/12 m-auto items-center sm:hidden md:inline',
        mediaWrapper: 'flex-grow flex-no-shrink flex-basis w-full',
        cardMedia: 'max-w-full',
        contentWrapper: 'px-15 w-full mt-20 pb-30 md:pb-0 button-contain md:w-12/12 sm:w-8/12 sm:float-left sm:text-left',
        heading: 'font-sans-bold text-lg leading-23 text-black md:text-5xl',
        description: 'font-sans-roma font-normal text-black text-lg leading-23 p-0 min-h-60 py-20 px-10',
        buttonContainer: 'w-full',
        button: ['btn btn-amber md:w-5/12', 'btn btn-compare mt-15 md:w-5/12'],
    },

    ShelfDefaultProducthb: {
        card: 'card multi-button-card flex flex-col text-center md:border-0 md:w-3/12 m-auto items-center md:w-3/12 m-auto items-center',
        mediaWrapper: 'flex-grow flex-no-shrink flex-basis flex md:flex-col-reverse w-full sm:flex-row-reverse sm:border-b md:border-none',
        cardMedia: 'max-w-full',
        contentWrapper: 'px-30 md:px-15 sm:pl-0 w-full mt-20 pb-30 md:pb-0 button-contain text-left md:text-center',
        heading: 'font-sans-bold block text-left md:text-center text-black text-15 leading-normal pt-2 pb-2 md:pr-4 md:pl-4',
        description: 'font-sans-roma font-normal  text-left md:text-center text-black text-lg leading-23 p-0 min-h-60  md:px-10',
        buttonContainer: 'w-full',
        button: ['btn btn-amber', 'btn btn-prodcompare mt-15'],
    },

    ShelfDefaultProducthblast: {
        card: 'card multi-button-card flex flex-col text-center md:border-0 md:w-3/12 m-auto items-center md:w-3/12 m-auto items-center',
        mediaWrapper: 'flex-grow flex-no-shrink flex-basis flex md:flex-col-reverse w-full sm:flex-row-reverse',
        cardMedia: 'max-w-full',
        contentWrapper: 'px-30 md:px-15 sm:pl-0 w-full mt-20 pb-30 md:pb-0 button-contain text-left md:text-center',
        heading: 'font-sans-bold block text-left md:text-center text-black text-15 leading-normal pt-2 pb-2 md:pr-4 md:pl-4',
        description: 'font-sans-roma font-normal  text-left md:text-center text-black text-lg leading-23 p-0 min-h-60  md:px-10',
        buttonContainer: 'w-full',
        button: ['btn btn-amber', 'btn btn-prodcompare mt-15'],
    },

  ShelfDefaultProductlncamp: {
      card: 'card multi-button-card flex flex-col text-center md:border-0 md:w-3/12 m-auto items-center md:w-3/12 m-auto items-center',
      mediaWrapper: 'flex-grow flex-no-shrink flex-basis w-full',
      cardMedia: 'max-w-full',
      contentWrapper: 'px-15 w-full mt-20 pb-30 md:pb-0 button-contain',
      heading: 'font-sans-bold text-lg leading-23 text-black md:text-5xl',
      description: 'font-sans-roma font-normal text-black text-lg leading-23 p-0 min-h-60 py-20 px-10 md:min',
      buttonContainer: 'w-full',
      button: ['btn btn-amber w-5/12', 'btn btn-compare mt-15 w-5/12'],
  },
  'Discover-card-foil-vs-rotary': {
      card: 'card multi-button-card flex flex-col text-center md:border-0 md:w-3/12 m-auto items-center md:w-3/12 m-auto items-center sm:hidden md:inline',
      mediaWrapper: 'flex-grow flex-no-shrink flex-basis w-full',
      cardMedia: 'max-w-full',
      contentWrapper: 'px-15 w-full mt-20 pb-30 md:pb-0 button-contain md:w-12/12 sm:w-8/12 sm:float-left sm:text-left',
      heading: 'font-sans-bold text-lg leading-23 text-black md:text-5xl',
      description: 'font-sans-roma font-normal text-black text-lg leading-23 p-0 h-130 py-20 px-10 pt-20',
      buttonContainer: 'w-full',
      button: ['btn btn-amber md:w-5/12', 'btn btn-compare mt-15 md:w-5/12'],
  },
  panteneStoryStackedCard: {
      card: 'stacked-card flex flex-wrap sm:text-center md:flex md:justify-start w-full',
      mediaWrapper: 'flex flex-col w-full md:px-15',
      cardMedia: 'justify-center min-h-1',
      contentWrapper: '',
      cardContent: 'flex-grow flex-no-shrink flex-basis ',
      cardActions: 'px-6 py-1',
      header: 'font-BebasNeueRegular block text-left text-black text-20 md:text-18 sm:leading-22 md:leading-20 pt-10 sm:pb-0 md:pb-0 sm:pl-43 md:pl-0  tracking-wider',
      description: 'font-HelveticaNeueLight sm:text-18 md:text-14 sm:leading-28 leading-normal text-left lg:text-left text-black sm:pl-43 md:pl-0 mb-20 text-grey mt-' +
          '10',
      componentBox: 'component-box w-full text-center',
      button: ['mb-15 btn btn-solid', ''],
      buttonContainer: 'w-full',
  },
  RecycleSCStackedCard:{
    card: 'stacked-card flex flex-wrap sm:text-center md:flex md:justify-start w-full RecycleSCStackedCardimg',
    mediaWrapper: 'flex flex-col w-full px-0',
    cardMedia: 'justify-center min-h-1',
    contentWrapper: '',
    cardContent: 'flex-grow flex-no-shrink flex-basis ',
    cardActions: 'px-6 py-1',
    header: 'font-BebasNeueRegular block text-left text-black text-20 md:text-18 sm:leading-22 md:leading-20 pt-10 sm:pb-0 md:pb-0 sm:pl-43 md:pl-0  tracking-wider',
    description: 'font-BebasNeueRegular font-semibold sm:text-18 md:text-14 sm:leading-28 leading-normal text-left lg:text-left text-black sm:pl-43 md:pl-0 mb-20 RecycleSCStackedCardbox mt-' +
        '10',
    componentBox: 'component-box w-full text-center',
    button: ['mb-15 btn btn-solid', ''],
    buttonContainer: 'w-full',
  },
  RecycleThirdStackedCard:{
    card: 'stacked-card flex flex-wrap sm:text-center md:flex md:justify-start w-full p-2p m:p-0 relative RecycleThirdStackedCardimgcontainer',
    mediaWrapper: 'flex flex-col w-full md:px-15',
    cardMedia: 'justify-center min-h-1',
    contentWrapper: '',
    cardContent: 'flex-grow flex-no-shrink flex-basis ',
    cardActions: 'px-6 py-1',
    header: 'font-BebasNeueRegular block text-left text-black text-20 md:text-18 sm:leading-22 md:leading-20 pt-10 sm:pb-0 md:pb-0 sm:pl-0   tracking-wider',
    description: 'font-BebasNeueRegular font-semibold sm:text-18 md:text-14 sm:leading-28 leading-normal text-left lg:text-center text-black sm:pl-43 md:pl-0 mb-20  mt-' +
        '10',
    componentBox: 'component-box w-full text-center',
    button: ['mb-15 btn btn-solid', ''],
    buttonContainer: 'w-full',
  },
  EssenciasPanteneStoryStackedCard: {
    card:
    'stacked-card flex flex-wrap sm:text-center md:flex md:justify-start w-full',
  mediaWrapper: 'flex flex-col w-full md:px-15',
  cardMedia: 'justify-center min-h-1',
  contentWrapper: '',
  cardContent: 'flex-grow flex-no-shrink flex-basis ',
  cardActions: 'px-6 py-1 mb-40 buttonessential',
  header:
    'font-BebasNeueRegular block text-center text-black text-20 md:text-18 sm:leading-22 md:leading-20 pt-10 sm:pb-0 md:pb-0 md:pl-0  gradientUnderline',
    subTitle:
    'font-HelveticaNeueLight text-14 leading-20 leading-normal text-center mb-20  mx-auto md:w-full w-90p text-black mt-' +
    '10',
  description:
    'font-HelveticaNeueLight text-14 leading-28 leading-normal text-center mb-20  mx-auto md:w-full w-90p text-black essentialDescription mt-' +
    '10',
  componentBox: 'component-box w-full text-center',
  button: ['mb-15 btn btn-solid', ''],
  buttonContainer: 'w-full',
  },
  'um-cabelo-card': {
      card: 'hair-gender-card umCabeloCardHeading flex flex-row flex-wrap relative mx-0 md:mx-15 umCabeloCardImageBox',
      cardTitle: 'my-10 md:mt-25 md:mb-40',
      mediaWrapper: 'sm:w-full text-center md:content-center pt-10 md:pt-0',
      cardMedia: 'w-full md:text-center imageCard',
      contentWrapper: 'contentWrapper bg-white w-90p mx-auto text-center -mt-90 pb-60 p-15 md:pb-15 md:p-15 h-auto md:h-400 relative',
      cardContent: 'w-full  md:px-0 text-s13-m13-l15 text-black',
      cardActions: 'w-full  md:px-0 ',
      cardText: 'font-HelveticaNeueLight sm:text-16 md:text-18 md:leading-28 text-black',
      button: ['', ''],
  },
  SafetySixthHoriziontalCard:{
    card: 'hair-gender-card SafetySixthHoriziontalCard flex flex-row flex-wrap relative md:pr-10 md:w-full w-11/12',
    cardTitle: 'my-10 md:mt-25 md:mb-40',
    mediaWrapper: 'sm:w-full text-center md:content-center pt-10 md:pt-0',
    cardMedia: ' w-30 md:w-full md:text-center',
    contentWrapper: 'contentWrapper bg-white w-90p mx-auto text-center md:-mt-90 -mt-50 pb-60 p-15 md:pb-15 md:p-15 h-auto md:h-130 relative',
    cardContent: 'w-full  md:px-0 text-s13-m13-l15 text-black',
    cardActions: 'w-full  md:px-0 ',
    cardText: 'font-HelveticaNeueLight text-12 leading-20 text-black',
    button: ['', ''],
    },
    SafetySixthHoriziontalCard2:{
        card: 'hair-gender-card SafetySixthHoriziontalCard2 flex flex-row flex-wrap relative md:pl-10 md:w-full w-11/12',
        cardTitle: 'my-10 md:mt-25 md:mb-40',
        mediaWrapper: 'sm:w-full text-center md:content-center pt-10 md:pt-0',
        cardMedia: ' w-30 md:w-full md:text-center',
        contentWrapper: 'contentWrapper bg-white w-90p mx-auto text-center md:-mt-90 -mt-50 pb-60 p-15 md:pb-15 md:p-15 h-auto md:h-130 relative',
        cardContent: 'w-full  md:px-0 text-s13-m13-l15 text-black',
        cardActions: 'w-full  md:px-0 ',
        cardText: 'font-HelveticaNeueLight text-12 leading-20 text-black',
        button: ['', ''],
      },
  'ManifestoHorizontalCard': {
      card: 'hair-gender-card umCabeloCardHeading flex flex-row flex-wrap relative mx-0 md:mx-15 commonBannerSeven',
      cardTitle: 'my-10 md:mt-25 md:mb-40',
      cardSubTitle: 'my-10 md:mt-25 md:mb-20 text-2.3vw font-semibold Manifestoheading font-BebasNeueBold',
      mediaWrapper: 'sm:w-full text-center md:content-center pt-10 md:pt-0',
      cardMedia: ' w-30 md:w-full md:text-center',
      contentWrapper: 'contentWrapper bg-white mx-auto md:mx-0 w-90p md:w-50p leading-2.5v md:text-left -mt-90 p-4p h-auto md:h-32v relative manifestoHorizontalCardcontainer',
      cardContent: 'w-full  md:px-0 text-s13-m13-l15 text-black',
      cardActions: 'w-full  md:px-0 ',
      cardText: 'font-HelveticaNeueLight text-justify text-12 leading-20 text-black Manifestopara',
      button: ['', ''],
  },
  'BeneficialHorizontalCard': {
    card:
      'hair-gender-card BeneficialHorizontalCard flex flex-row flex-wrap relative md:mr-10',
    cardTitle: 'my-10 md:mt-20 md:mb-20 mx-20 text-left lowercase font-BebasNeueBold text-20 leading-24',
    mediaWrapper: 'sm:w-full text-center md:content-center pt-10 md:pt-0',
    cardMedia: ' w-30 md:w-full md:text-center',
    contentWrapper:
      'contentWrapper bg-white w-full md:w-90p mx-auto text-center -mt-20 md:-mt-150 pb-60 p-15 md:pb-15 md:p-15 h-auto md:h-300 relative',
    cardContent: 'w-full  md:px-0 text-s13-m13-l15 text-black',
    cardActions: 'w-full  md:px-0 ',
    cardText:
      'font-HelveticaNeueLight text-12 leading-20 text-black text-justify px-20 py-0',
    button: ['', ''],
    supportingText: 'supportingText safetyCard text-left'
  },
  'EssencialHorizontalCard': {
    card:
      'hair-gender-card EssencialHorizontalCard flex flex-row flex-wrap relative md:ml-10',
    cardTitle: 'my-10 md:mt-20 md:mb-20 mx-20 text-left lowercase font-BebasNeueBold text-20 leading-24',
    mediaWrapper: 'sm:w-full text-center md:content-center pt-10 md:pt-0',
    cardMedia: ' w-30 md:w-full md:text-center',
    contentWrapper:
      'contentWrapper bg-white w-full md:w-90p mx-auto text-center -mt-20 md:-mt-150 pb-60 p-15 md:pb-15 md:p-15 h-auto md:h-300 relative',
    cardContent: 'w-full  md:px-0 text-s13-m13-l15 text-black',
    cardActions: 'w-full  md:px-0 ',
    cardText:
      'font-HelveticaNeueLight text-12 leading-20 text-black text-justify px-20 py-0',
    button: ['', ''],
    supportingText: 'supportingText safetyCard text-left'
  },
};